import { formatMoney } from '../../utils/Utils';
import { Link } from 'react-router-dom';
import useCartStore from '../../stores/cart.store';
import CartButton from './CartButton';
import { ProductListItem } from '@/types/api/product';
import { Image } from '../image';

type ProductListingProps = { product: ProductListItem };

const ProductListing = ({ product }: ProductListingProps) => {
  const addItem = useCartStore((state) => state.addItem);
  const item = useCartStore((state) => state.items).find((item) => item.id === product.id);
  const updateQuantity = useCartStore((state) => state.updateQuantity);

  return (
    <>
      <div className="col-span-12 min-[380px]:col-span-6 sm:col-span-4 md:col-span-4 lg:col-span-3 xl:col-span-2  bg-white dark:bg-gray-800 shadow-sm rounded-xl overflow-hidden">
        <div className="flex flex-col h-full">
          <Link to={product.id}>
            {/* Image */}
            {product.primaryMedia && (
              <Image
                sizes="260px"
                renditions={Object.values(product.primaryMedia.renditions)}
                alt={product.primaryMedia.name}
              />
            )}
          </Link>
          {/* Card Content */}
          <div className="grow flex flex-col p-4">
            <Link to={product.id} className="mb-auto">
              {/* Card body */}
              <div className="grow">
                <header className="mb-1">
                  <h3 className="truncate text-sm text-gray-800 dark:text-gray-100 font-semibold">{product.name}</h3>
                </header>
              </div>

              <div className="text-xl text-gray-800 dark:text-gray-100 font-semibold mb-2 md:mb-4">
                {formatMoney(product.price)}
              </div>
            </Link>

            <CartButton
              onChange={(value) => updateQuantity(product.id, value)}
              value={item?.quantity}
              addToCart={() =>
                addItem({
                  id: product.id,
                  name: product.name,
                  tagline: product.tagline,
                  price: product.price,
                  thumbnail: product.primaryMedia?.renditions.THUMBNAIL,
                })
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductListing;
